import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  Pressable,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useState } from "react";
import AppFonts from "../../../Constants/AppFonts";
import AppColors from "../../../Constants/AppColors";
import AppImages from "../../../Constants/AppImages";
// import {
//   VictoryArea,
//   VictoryLine,
//   VictoryChart,
//   VictoryAxis,
// } from "victory-native";
import {
  Inslight,
  LastLogin,
  LastLoginView,
  ModaDel,
  ModalDel,
} from "../../../Constants/Data";
import Appstyles from "../../../Constants/AppStyles";
import UserInsightCalender from "../../../Components/UserInsightCalender";
// import CustomGraphDaliy from "../../../Components/CustomGraphDaliy";
// import CustomGraphWeekly from "../../../Components/CustomGraphweekly";
// import CustomGraphMonth from "../../../Components/CustomGraphMonth";
// import CustomGraphWeeklyhauuuuu from "../../../../Rahil";
// import BarChartCustom from "../../../../CustBarChart";
// import BarChartCustom from "../../../Components/

import Calendercustomchart from "../../../Components/Calendercustomchart";

const { width, height } = Dimensions.get("window");

const data = [
  { x: 1, y: 50, y2: 200 },
  { x: 2, y: 105, y2: 32 },
  { x: 3, y: 170, y2: 15 },
  { x: 4, y: 100, y2: 28 },
  { x: 5, y: 204, y2: 30 },
];
const dataone = [
  { x: 1, y: 51, y2: 200 },
  { x: 2, y: 106, y2: 10 },
  { x: 3, y: 171, y2: 15 },
  { x: 4, y: 101, y2: 30 },
  { x: 5, y: 205, y2: 38 },
];
const UserInsightDaily = ({ navigation }) => {
  const [color, setColor] = useState([
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
  ]);
  const datas = [
    {
      name: "15",
      value: 357366,
      percent: "60%",
    },
    {
      name: "16",
      value: 7851,
      percent: "300%",
    },
    {
      name: "17",
      value: 798915,
      percent: "100%",
    },
    {
      name: "18",
      value: 357366,
      percent: "300%",
    },
    {
      name: "19",
      value: 322,
      percent: "400%",
    },
    {
      name: "20",
      value: 357366,
      percent: "600%",
    },
  ];

  const [colorweekly, setweekly] = useState([
    "#761CD4",
    "#761CD4",
    "#761CD4",
    "#761CD4",
    "#761CD4",
    "#761CD4",
    "#761CD4",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
    "#D5297F",
  ]);
  const datasweekly = [
    {
      name: "",
      value: 357366,
      percent: "100%",
    },
    {
      name: "",
      value: 7851,
      percent: "200%",
    },
    {
      name: "Week 1",
      value: 798915,
      percent: "150%",
    },
    {
      name: "",
      value: 357366,
      percent: "250%",
    },
    {
      name: "",
      value: 322,
      percent: "50",
    },
    {
      name: "",
      value: 357366,
      percent: "155%",
    },
    {
      name: "",
      value: 357366,
      percent: "195%",
    },
    {
      name: "",
      value: 357366,
      percent: "165%",
    },
    {
      name: "",
      value: 357366,
      percent: "117%",
    },
    {
      name: "Week 2",
      value: 357366,
      percent: "188%",
    },
    {
      name: "",
      value: 357366,
      percent: "133%",
    },
    {
      name: "",
      value: 357366,
      percent: "155%",
    },
    {
      name: "",
      value: 357366,
      percent: "165%",
    },
    {
      name: "",
      value: 357366,
      percent: "176%",
    },
  ];

  const [colorMonthly, setMonthly] = useState([
    "#FF7621",
    "#761CD4",
    "#D5297F",
    "#761CD4",
    "#FF7621",
    "#D5297F",
    "#21C47B",
    "#D5297F",
    "#761CD4",
    "#FF7621",
    "#21C47B",
  ]);
  const datasMonthly = [
    {
      name: "Jan",
      value: 357366,
      percent: "100%",
    },
    {
      name: "Feb",
      value: 7851,
      percent: "200%",
    },
    {
      name: "Mar",
      value: 798915,
      percent: "150%",
    },
    {
      name: "Apr",
      value: 357366,
      percent: "250%",
    },
    {
      name: "May",
      value: 322,
      percent: "50",
    },
    {
      name: "Jun",
      value: 357366,
      percent: "155%",
    },
    {
      name: "Jul",
      value: 357366,
      percent: "195%",
    },
    {
      name: "Aug",
      value: 357366,
      percent: "165%",
    },
    {
      name: "Sep",
      value: 357366,
      percent: "117%",
    },
    {
      name: "Nov",
      value: 357366,
      percent: "188%",
    },
    {
      name: "Dec",
      value: 357366,
      percent: "133%",
    },
  ];

  const [selectedData, setSelectedData] = useState(null);

  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const handleButtonPress = (index) => {
    setSelectedButtonIndex(index);
  };
  const [selectedItem, setSelectedItem] = useState(null);

  const [DotModal, setDotModal] = useState(false);

  const [selectedButton, setSelectedButton] = React.useState(0);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  return (
    <SafeAreaView style={Appstyles.safe}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={Appstyles.ArrowImage} />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Users Insight</Text>
        </View>
        <View style={Appstyles.rc}>
          <Image
            source={AppImages.VechicleNoti}
            style={Appstyles.VehicleImage}
            resizeMode="contain"
          />

          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={Appstyles.safedown}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={Appstyles.AsddwPaids7}>
            <View style={Appstyles.Anno7}>
              <View style={Appstyles.Searchvi6}>
                <TextInput
                  style={Appstyles.TextInput7}
                  placeholder="Search Car..."
                  placeholderTextColor={"#AAAAAA"}
                  editable={true}
                  // value={searchText}

                  autoCapitalize="none"
                  // onChangeText={(text) => setsearchText(text)}
                />

                <View style={Appstyles.SearchImageView}>
                  <Image
                    source={AppImages.search}
                    style={Appstyles.SearchImage}
                  />
                </View>
              </View>

              <Image
                source={AppImages.Import}
                style={Appstyles.ImpoShare7}
                resizeMode="contain"
              />

              <Image
                source={AppImages.Shareit}
                style={Appstyles.ImpoShare7}
                resizeMode="contain"
              />
            </View>
          </View>

          <View style={{}}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <View style={{ flexDirection: "row" }}>
                <View
                  style={{
                    width: "35%",
                    marginLeft: 20,
                  }}
                >
                  <UserInsightCalender placeholder="Date from" />
                </View>
                <View style={{ width: "35%", marginLeft: 20 }}>
                  <UserInsightCalender placeholder="Date To" />
                </View>
              </View>

              <TouchableOpacity onPress={() => setDotModal(true)}>
                <Image
                  source={AppImages.QuestionPic}
                  resizeMode="contain"
                  style={{ width: 50, height: 40 }}
                />
              </TouchableOpacity>
            </View>
          </View>

          <View
            style={{
              borderWidth: 0.5,

              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
              borderRadius: 10,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <Text
                  style={{
                    color: AppColors.brown1,
                    fontFamily: AppFonts.OverpassSemiBold,
                    fontSize: 18,
                  }}
                >
                  User’s Summary
                </Text>
              </View>
              <View style={{ marginHorizontal: 20 }}>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 20,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <View style={{}}>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 14,
                      }}
                    >
                      Total Users
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 18,
                      }}
                    >
                      600
                    </Text>
                  </View>
                  <View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          backgroundColor: "#04B54C",

                          marginTop: 20,
                          padding: 10,
                          paddingLeft: 20,
                          paddingRight: 20,

                          borderRadius: 20,
                        }}
                      >
                        <Text
                          style={{
                            color: AppColors.white,
                            fontFamily: AppFonts.OverpassMedium,
                            fontSize: 12,
                          }}
                        >
                          Increased by 50%
                        </Text>
                      </View>
                      <View style={{ marginTop: 20, marginLeft: 5 }}>
                        <Image
                          source={AppImages.UpArrowGreen}
                          resizeMode="contain"
                          style={{ width: 14.08, height: 14.92 }}
                        />
                      </View>
                    </View>
                    <View style={{ flexDirection: "row", marginTop: 5 }}>
                      <Text
                        style={{
                          color: AppColors.dualbrown,

                          fontSize: 12,
                          marginLeft: 4,
                        }}
                      >
                        *
                      </Text>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontFamily: AppFonts.OverpassMedium,
                          fontSize: 12,
                          marginLeft: 4,
                        }}
                      >
                        As per last month
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View
              style={{
                borderWidth: 0.5,
                borderColor: AppColors.dualbrown,
                marginTop: 15,
                opacity: 0.27,
              }}
            ></View>

            <View
              style={{ marginHorizontal: 20, marginTop: 10, marginBottom: 15 }}
            >
              <View style={{ flexDirection: "row" }}>
                <View style={{ flexDirection: "row", width: "60%" }}>
                  <View style={{ justifyContent: "center" }}>
                    <Image
                      source={AppImages.ManLock}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View style={{ marginLeft: 10, width: "60%" }}>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Administrator
                    </Text>
                  </View>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Image
                      source={AppImages.BusFleet}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View style={{ marginLeft: 10, width: "40%" }}>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Fleet Manager
                    </Text>
                  </View>
                </View>
              </View>

              <View style={{ flexDirection: "row", marginTop: 15 }}>
                <View style={{ flexDirection: "row", width: "60%" }}>
                  <View
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Image
                      source={AppImages.SettingsCar}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View style={{ marginLeft: 10, width: "60%" }}>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Transport Manager
                    </Text>
                  </View>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Image
                      source={AppImages.Assistant}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View style={{ marginLeft: 10, width: width * 0.2 }}>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Vehicle Assistant
                    </Text>
                  </View>
                </View>
              </View>

              <View style={{ flexDirection: "row", marginTop: 15 }}>
                <View style={{ flexDirection: "row", width: "60%" }}>
                  <View
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Image
                      source={AppImages.DriverR}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View style={{ marginLeft: 10, width: "60%" }}>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Drivers
                    </Text>
                  </View>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{ alignItems: "center", justifyContent: "center" }}
                  >
                    <Image
                      source={AppImages.Others}
                      resizeMode="contain"
                      style={{ width: 44, height: 44 }}
                    />
                  </View>
                  <View
                    style={{
                      marginLeft: 10,
                      justifyContent: "center",
                      width: "40%",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 20,
                      }}
                    >
                      10
                    </Text>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                        marginTop: -6,
                      }}
                    >
                      Others
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>

          <View
            style={{
              borderWidth: 0.5,

              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
              borderRadius: 10,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <Text
                  style={{
                    color: AppColors.brown1,
                    fontFamily: AppFonts.OverpassSemiBold,
                    fontSize: 18,
                  }}
                >
                  Device Logins
                </Text>
              </View>
              <View style={{ marginHorizontal: 20, marginTop: 20 }}>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      width: "60%",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 14,
                      }}
                    >
                      Web Logins
                    </Text>
                    <View
                      style={{
                        width: 8,
                        height: 8,
                        backgroundColor: AppColors.brown,
                        borderRadius: 100,
                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                  </View>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 14,
                      }}
                    >
                      Mobile Logins
                    </Text>
                    <View
                      style={{
                        width: 8,
                        height: 8,
                        backgroundColor: AppColors.dualbrown,
                        borderRadius: 100,
                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                  </View>
                </View>
                {/* <View style={{ width: "100%", marginHorizontal: -20 }}>
                  <VictoryChart>
                    <VictoryAxis
                      tickValues={[1, 2, 3, 4, 5]} // X-axis labels
                      tickFormat={["1", "2", "3", "4", "5"]} // X-axis tick labels
                    />
                    <VictoryAxis
                      dependentAxis
                      tickValues={[100, 200, 300, 400, 500]} // Y-axis labels
                      tickFormat={["100", "200", "300", "400", "500"]} // Y-axis tick labels
                    />
                    <VictoryArea
                      data={data}
                      interpolation="natural"
                      events={[
                        {
                          target: "data",
                          eventHandlers: {},
                        },
                      ]}
                      style={{
                        data: { fill: "#C7A180", fillOpacity: 0.7 },
                      }}
                    />
                    <VictoryLine
                      data={dataone}
                      interpolation="natural"
                      style={{
                        data: {
                          stroke: "#8F4300",
                          fill: "#8F4300",
                          fillOpacity: 0.7,
                        },
                      }}
                    />
                  </VictoryChart>
                </View> */}
              </View>
            </View>
          </View>
          <View
            style={{
              borderWidth: 0.5,
              borderRadius: 10,
              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <View style={{ width: "45%" }}>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 18,
                      }}
                    >
                      Top Time spends by User’s
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row", paddingTop: 3 }}>
                    <TouchableOpacity onPress={() => [handleButtonPress(0)]}>
                      <Text
                        style={{
                          // color: AppColors.brown1,
                          fontFamily: AppFonts.OverpassSemiBold,
                          fontSize: 12,
                          color:
                            selectedButtonIndex === 0
                              ? AppColors.brown1
                              : AppColors.dualbrown,
                        }}
                      >
                        Daily
                      </Text>
                    </TouchableOpacity>
                    <Text
                      style={{
                        color:
                          selectedButtonIndex === 0
                            ? AppColors.dualbrown
                            : AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      |
                    </Text>
                    <TouchableOpacity onPress={() => [handleButtonPress(1)]}>
                      <Text
                        style={{
                          color:
                            selectedButtonIndex === 1
                              ? AppColors.brown1
                              : AppColors.dualbrown,
                          fontFamily: AppFonts.OverpassSemiBold,
                          fontSize: 12,
                          marginLeft: 5,
                        }}
                      >
                        Weekly
                      </Text>
                    </TouchableOpacity>
                    <Text
                      style={{
                        color:
                          selectedButtonIndex === 1
                            ? AppColors.brown1
                            : AppColors.dualbrown,
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      |
                    </Text>
                    <TouchableOpacity onPress={() => [handleButtonPress(2)]}>
                      <Text
                        style={{
                          color:
                            selectedButtonIndex === 2
                              ? AppColors.brown1
                              : AppColors.dualbrown,

                          fontFamily: AppFonts.OverpassSemiBold,
                          fontSize: 12,
                          marginLeft: 5,
                        }}
                      >
                        Monthly
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
              <View style={{ marginHorizontal: 20, marginTop: 20 }}>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 14,
                      }}
                    >
                      Total Spend by
                    </Text>
                    <View
                      style={{
                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontFamily: AppFonts.OverpassBold,
                          fontSize: 18,
                        }}
                      >
                        Driver
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={{ marginTop: 20, marginBottom: 20 }}>
                  {selectedButtonIndex === 0 ? (
                    <View style={{}}>
                      <View style={{ flex: 1 }}>
                        <View style={{ paddingRight: 3 }}>
                          {/* <View style={{}}>
                            <BarChartCustom
                              data={datas}
                              colorBarChart={color}
                            />
                            <View
                              style={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "row",
                              }}
                            >
                              <View style={{ width: "22%" }}>
                                <Calendercustomchart />
                              </View>
                              {datas.map((list, index) => (
                                <View style={{ width: "45%", flex: 1 }}>
                                  <ScrollView nestedScrollEnabled>
                                    <Text
                                      style={{ fontSize: 12, color: "#8F4300" }}
                                    >
                                      {list.name}
                                    </Text>
                                  </ScrollView>
                                </View>
                              ))}
                            </View>
                          </View> */}
                        </View>
                      </View>
                    </View>
                  ) : null}

                  {selectedButtonIndex === 1 ? (
                    <View style={{}}>
                      <View style={{ flex: 1 }}>
                        <View style={{ paddingRight: 3 }}>
                          {/* <View style={{}}>
                            <BarChartCustom
                              data={datasweekly}
                              colorBarChart={colorweekly}
                            />
                            <View
                              style={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "row",
                              }}
                            >
                              <View style={{ width: "22%" }}>
                                <Calendercustomchart />
                              </View>
                              {datasweekly.map((list, index) => (
                                <View style={{}}>
                                  <ScrollView nestedScrollEnabled>
                                    <Text
                                      style={{ fontSize: 12, color: "#8F4300" }}
                                    >
                                      {list.name}
                                    </Text>
                                  </ScrollView>
                                </View>
                              ))}
                            </View>
                          </View> */}
                        </View>
                      </View>
                    </View>
                  ) : null}
                  {selectedButtonIndex === 2 ? (
                    <View style={{}}>
                      <View style={{ flex: 1 }}>
                        <View style={{ paddingRight: 3 }}>
                          {/* <View style={{}}>
                            <BarChartCustom
                              data={datasMonthly}
                              colorBarChart={colorMonthly}
                            />
                            <View
                              style={{
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "row",
                              }}
                            >
                              <View style={{ width: "18%" }}>
                                <Calendercustomchart />
                              </View>
                              {datasMonthly.map((list, index) => (
                                <View style={{ flex: 1 }}>
                                  <ScrollView nestedScrollEnabled>
                                    <Text
                                      style={{ fontSize: 12, color: "#8F4300" }}
                                    >
                                      {list.name}
                                    </Text>
                                  </ScrollView>
                                </View>
                              ))}
                            </View>
                          </View> */}
                        </View>
                      </View>
                    </View>
                  ) : null}
                </View>
              </View>
              <View style={{ marginHorizontal: 20 }}>
                <View style={{ flexDirection: "row" }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",

                      width: "30%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#D5297F",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <View style={{}}>
                      <Text
                        style={{
                          color: AppColors.brown,
                          fontFamily: AppFonts.OverpassMedium,
                          fontSize: 10,
                          marginLeft: 5,
                        }}
                      >
                        Driver
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",

                      width: "35%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#2F7DD3",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      Fleet Manager
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",

                      width: "35%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#FF7621",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      Transport Manager
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  marginHorizontal: 20,
                  marginTop: 10,
                  marginBottom: 15,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      width: "30%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#761CD4",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      Administrator
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      width: "35%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#21C47B",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      Vehicle Assistant
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      width: "35%",
                    }}
                  >
                    <View
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: "#F3CF26",

                        marginLeft: 10,
                        alignItems: "center",
                      }}
                    ></View>
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 10,
                        marginLeft: 5,
                      }}
                    >
                      Other’s
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>

          <View
            style={{
              borderWidth: 0.5,

              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
              borderRadius: 10,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <Text
                  style={{
                    color: AppColors.brown1,
                    fontFamily: AppFonts.OverpassSemiBold,
                    fontSize: 18,
                  }}
                >
                  Last Activities
                </Text>
              </View>
              <View style={{ marginBottom: 10 }}>
                <FlatList
                  data={Inslight}
                  renderItem={({ item, index }) => (
                    <View
                      style={{
                        marginHorizontal: 20,
                        marginTop: 10,
                      }}
                    >
                      <View style={{ flexDirection: "row" }}>
                        <View
                          style={{
                            width: width * 0.44,

                            flexDirection: "row",
                          }}
                        >
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassBold,
                            }}
                          >
                            {item.Data}
                          </Text>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassBold,
                            }}
                          >
                            {item.Time}
                          </Text>
                        </View>

                        <View style={{ width: "45%" }}>
                          <Text>
                            <Text
                              style={{
                                color: AppColors.brown,
                                fontSize: 14,
                                fontFamily: AppFonts.OverpassBold,
                              }}
                            >
                              {item.H1}
                              <Text
                                style={{
                                  color: AppColors.dualbrown,
                                  fontSize: 14,
                                  fontFamily: AppFonts.OverpassBold,
                                }}
                              >
                                {""} {item.H2}{" "}
                              </Text>
                              <Text
                                style={{
                                  color: AppColors.brown,
                                  fontSize: 14,
                                  fontFamily: AppFonts.OverpassBold,
                                }}
                              >
                                {""}
                                {item.H3}{" "}
                              </Text>
                              <Text
                                style={{
                                  color: AppColors.dualbrown,
                                  fontSize: 14,
                                  fontFamily: AppFonts.OverpassBold,
                                }}
                              >
                                {""}
                                {item.H4}{" "}
                              </Text>
                              <Text
                                style={{
                                  color: AppColors.brown,
                                  fontSize: 14,
                                  fontFamily: AppFonts.OverpassBold,
                                }}
                              >
                                {" "}
                                {item.H5}
                                {""}
                              </Text>
                            </Text>
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}
                />
              </View>
            </View>
          </View>

          <View
            style={{
              borderWidth: 0.5,

              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
              borderRadius: 10,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <Text
                  style={{
                    color: AppColors.brown1,
                    fontFamily: AppFonts.OverpassSemiBold,
                    fontSize: 18,
                  }}
                >
                  Last Login’s
                </Text>
              </View>
              <View style={{ marginBottom: 10 }}>
                <FlatList
                  data={LastLogin}
                  renderItem={({ item, index }) => (
                    <View
                      style={{
                        marginHorizontal: 20,
                        marginTop: 10,
                      }}
                    >
                      <View style={{ flexDirection: "row" }}>
                        <View
                          style={{
                            width: width * 0.44,

                            flexDirection: "row",
                          }}
                        >
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassBold,
                            }}
                          >
                            {item.Data}
                          </Text>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassBold,
                            }}
                          >
                            {item.Time}
                          </Text>
                        </View>

                        <View style={{ width: "45%" }}>
                          <Text style={{}}>
                            <Text
                              style={{
                                color: AppColors.brown,
                                fontSize: 14,
                                fontFamily: AppFonts.OverpassBold,
                              }}
                            >
                              {item.H1}
                              <Text
                                style={{
                                  color: AppColors.dualbrown,
                                  fontSize: 14,
                                  fontFamily: AppFonts.OverpassBold,
                                }}
                              >
                                {""} {item.H2}{" "}
                              </Text>
                            </Text>
                          </Text>
                        </View>
                      </View>
                    </View>
                  )}
                />
              </View>
            </View>
          </View>

          <View
            style={{
              borderWidth: 0.5,

              borderColor: AppColors.dualbrown,
              marginHorizontal: 20,
              marginTop: 20,
              borderRadius: 10,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  padding: 20,
                  borderRadius: 10,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontFamily: AppFonts.OverpassSemiBold,
                      fontSize: 18,
                    }}
                  >
                    Last Login’s
                  </Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("UserAlert")}
                  >
                    <Text
                      style={{
                        color: AppColors.dualbrown,
                        fontFamily: AppFonts.OverpassMedium,
                        fontSize: 12,
                      }}
                    >
                      View All
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
              <FlatList
                ListFooterComponent={<View style={{ padding: 20 }}></View>}
                data={LastLoginView}
                renderItem={({ item, index }) => (
                  <TouchableOpacity
                    style={{
                      borderRadius: 10,
                      borderWidth: selectedItem === item ? 0 : 1,
                      borderColor: AppColors.brown,
                      marginHorizontal: 20,
                      marginTop: 20,
                    }}
                    onPress={() => setSelectedItem(item)}
                  >
                    <View
                      style={{
                        marginHorizontal: 10,
                        marginTop: 10,
                        marginBottom: 10,
                      }}
                    >
                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <View style={{ width: "60%" }}>
                          <Text
                            style={{
                              color: AppColors.dualbrown,
                              fontSize: 12,
                              fontFamily: AppFonts.OverpassMedium,
                            }}
                          >
                            Users Name
                          </Text>
                        </View>

                        <View>
                          <Text
                            style={{
                              color: AppColors.dualbrown,
                              fontSize: 12,
                              fontFamily: AppFonts.OverpassMedium,
                            }}
                          >
                            Alert Name
                          </Text>
                        </View>
                      </View>

                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <View style={{ width: "60%" }}>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassSemiBold,
                            }}
                          >
                            {item.Name}
                          </Text>
                        </View>

                        <View>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassSemiBold,
                            }}
                          >
                            {item.Alert}
                          </Text>
                        </View>
                      </View>

                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <View style={{ width: "60%" }}>
                          <Text
                            style={{
                              color: AppColors.dualbrown,
                              fontSize: 12,
                              fontFamily: AppFonts.OverpassMedium,
                            }}
                          >
                            Date & Time
                          </Text>
                        </View>

                        <View>
                          <Text
                            style={{
                              color: AppColors.dualbrown,
                              fontSize: 12,
                              fontFamily: AppFonts.OverpassMedium,
                            }}
                          >
                            Location
                          </Text>
                        </View>
                      </View>

                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <View style={{ width: "60%" }}>
                          <View style={{ flexDirection: "row" }}>
                            <Text
                              style={{
                                color: AppColors.brown,
                                fontSize: 14,
                                fontFamily: AppFonts.OverpassSemiBold,
                              }}
                            >
                              {item.Data}
                            </Text>
                            <Text
                              style={{
                                color: AppColors.brown,
                                fontSize: 14,
                                fontFamily: AppFonts.OverpassSemiBold,
                              }}
                            >
                              {item.Time}
                            </Text>
                          </View>
                        </View>

                        <View style={{ width: "40%" }}>
                          <Text
                            style={{
                              color: AppColors.brown,
                              fontSize: 14,
                              fontFamily: AppFonts.OverpassSemiBold,
                              // marginRight:8
                              // backgroundColor:'red'
                            }}
                          >
                            {item.Location}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </TouchableOpacity>
                )}
              />
            </View>
          </View>
        </ScrollView>
      </View>
      <Modal
        animationType="slide"
        transparent={true}
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(!DotModal);
        }}
      >
        <Pressable onPress={() => setDotModal(false)} style={styles.presse}>
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>What is User’s Insight ?</Text>
                </View>
              </View>
            </View>
            <View style={{}}></View>
            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsdss}>
                User insights sum up your users’ perceptions and feelings about
                your product or service. These Insights are distilled by
                synthesizing and analyzing feedback collected from different
                sources and in-app user behavior. Whether positive or negative,
                user insights should be presented in simple ways that teams can
                act on for better decision-making.
              </Text>
            </View>
            <View style={styles.fasfdd}>
              <Text style={styles.sdsds}>Was this information helpful ?</Text>
            </View>
            <View
              style={{
                borderWidth: 0.51,
                borderColor: "#F6EFE9",
                marginTop: 10,
              }}
            ></View>
            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModaDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setDotModal(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setDotModal(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </SafeAreaView>
  );
};

export default UserInsightDaily;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },

  //------header-----
  HeaderMain: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: AppColors.white,
    height: 58,
    justifyContent: "space-between",
    paddingHorizontal: 20,
    shadowColor: AppColors.brown,

    shadowOffset: { width: 10, height: 10 },
    shadowOpacity: 10,
    shadowRadius: 10,
    elevation: 10,
  },
  HeaderSec: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HeaderBackTouch: { height: 30, width: 30, justifyContent: "center" },
  HeaderBackImage: { width: 8, height: 15 },
  HeadTextVechicle: {
    color: "#8F4300",
    fontFamily: AppFonts.OverpassSemiBold,
    fontSize: 16,
  },
  ImagesView: {
    flexDirection: "row",
    alignItems: "center",
  },
  img: { width: 20, height: 20 },
  imgg: { width: 16, height: 20, marginLeft: 20 },

  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22 },

  //----Modal

  //--------modal Del
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "flex-end",
    paddingTop: 60,
  },
  dsdd: {
    backgroundColor: "white",

    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12 },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  fasfdd: { marginTop: 60, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  sdsdss: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 16,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 10,
  },
  toda: { marginTop: 20, flexDirection: "row" },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
    marginLeft: 20,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
    marginLeft: 20,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderWidth: 0.5,
    borderColor: AppColors.grey,
    opacity: 0.2,
    marginTop: 10,
    marginHorizontal: 20,
  },
  vee: {
    alignItems: "flex-end",
    justifyContent: "center",
    flex: 1,
  },
});
